var _excluded = ["alignItems", "justifyContent", "direction", "wrap", "display", "gapSpace", "hasFullHeight", "children", "tabIndex"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from "react";
import styled, { css } from "styled-components";
import isNotEmpty from "../../../utils/isNotEmpty";
import space from "../../../utils/space";
import { defaultProps } from "./FlexContainerOrg.props";
var StyledFlexContainerOrg = styled.div.withConfig({
  componentId: "sc-e37j8p-0"
})(function (_ref) {
  var $alignItems = _ref.$alignItems,
    $justifyContent = _ref.$justifyContent,
    $direction = _ref.$direction,
    $wrap = _ref.$wrap,
    $display = _ref.$display,
    $gapSpace = _ref.$gapSpace,
    $hasFullHeight = _ref.$hasFullHeight;
  return css(["display:", ";flex-direction:", ";flex-wrap:", ";", " ", " ", " ", ""], $display, $direction, $wrap, isNotEmpty($hasFullHeight) ? css(["height:100%;"]) : null, isNotEmpty($alignItems) ? css(["align-items:", ";"], $alignItems) : null, isNotEmpty($justifyContent) ? css(["justify-content:", ";"], $justifyContent) : null, isNotEmpty($gapSpace) ? css(["gap:", ";"], typeof $gapSpace === "number" ? space($gapSpace) : "".concat(space($gapSpace.rowGap), " ").concat(space($gapSpace.columnGap))) : null);
});
var FlexContainerOrg = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var alignItems = _ref2.alignItems,
    justifyContent = _ref2.justifyContent,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? defaultProps.direction : _ref2$direction,
    _ref2$wrap = _ref2.wrap,
    wrap = _ref2$wrap === void 0 ? defaultProps.wrap : _ref2$wrap,
    _ref2$display = _ref2.display,
    display = _ref2$display === void 0 ? defaultProps.display : _ref2$display,
    gapSpace = _ref2.gapSpace,
    hasFullHeight = _ref2.hasFullHeight,
    children = _ref2.children,
    tabIndex = _ref2.tabIndex,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledFlexContainerOrg, _extends({
    ref: ref,
    $alignItems: alignItems,
    $justifyContent: justifyContent,
    $direction: direction,
    $wrap: wrap,
    $display: display,
    $hasFullHeight: hasFullHeight,
    $gapSpace: gapSpace,
    tabIndex: tabIndex
  }, restProps), children);
});
export default FlexContainerOrg;